import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n, { SUPPORTED_LANGUAGES } from "@/i18n";

export default function Footer() {
    const { t } = useTranslation();
    const { lang: paramLang } = useParams();
    const currentLang = SUPPORTED_LANGUAGES.includes(paramLang)
        ? paramLang
        : i18n.language;
    const base = `/${currentLang}`;

    const openCookiePreferences = () => {
        window.dispatchEvent(new CustomEvent("auronixra:open-cookie-preferences"));
    };

    const legal = t("footer.legal_details", { returnObjects: true });

    return (
        <footer className="aurx-footer">
            <div className="aurx-container">
                <div className="aurx-footer-grid">
                    <div>
                        <div
                            style={{
                                fontFamily: "Fraunces, serif",
                                fontSize: 24,
                                color: "var(--gold)",
                                marginBottom: 12,
                            }}
                        >
                            Auronixra
                        </div>
                        <p
                            className="aurx-footer-legal"
                            style={{ maxWidth: 320 }}
                        >
                            {t("footer.tagline")}
                        </p>
                    </div>

                    <div>
                        <h4>{t("footer.columns.navigate")}</h4>
                        <a href={`${base}#how`} data-testid="footer-how">
                            {t("nav.how")}
                        </a>
                        <br />
                        <a href={`${base}#projects`} data-testid="footer-projects">
                            {t("nav.projects")}
                        </a>
                        <br />
                        <a href={`${base}#trust`} data-testid="footer-trust">
                            {t("nav.trust")}
                        </a>
                        <br />
                        <a href={`${base}#contact`} data-testid="footer-contact">
                            {t("nav.contact")}
                        </a>
                    </div>

                    <div>
                        <h4>{t("footer.columns.legal")}</h4>
                        <Link
                            to={`${base}/privacy-policy`}
                            data-testid="footer-privacy"
                        >
                            {t("footer.links.privacy")}
                        </Link>
                        <br />
                        <Link
                            to={`${base}/cookie-policy`}
                            data-testid="footer-cookie"
                        >
                            {t("footer.links.cookie")}
                        </Link>
                        <br />
                        <Link
                            to={`${base}/terms-conditions`}
                            data-testid="footer-terms"
                        >
                            {t("footer.links.terms")}
                        </Link>
                        <br />
                        <button
                            onClick={openCookiePreferences}
                            className="aurx-footer-cookie-btn"
                            style={{
                                background: "transparent",
                                border: "none",
                                color: "var(--sand)",
                                opacity: 0.75,
                                padding: "4px 0",
                                cursor: "pointer",
                                fontFamily: "inherit",
                                fontSize: "inherit",
                                textAlign: "left",
                            }}
                            data-testid="footer-manage-cookies"
                        >
                            {t("footer.links.manage_cookies")}
                        </button>
                    </div>

                    <div>
                        <h4>{t("footer.columns.company")}</h4>
                        <p
                            className="aurx-footer-legal"
                            style={{ margin: 0 }}
                        >
                            <strong style={{ color: "var(--sand)" }}>
                                {legal.company_name}
                            </strong>
                            <br />
                            {legal.registered_office}
                            <br />
                            {legal.operational_office}
                            <br />
                            {legal.share_capital}
                            <br />
                            {legal.rea}
                            <br />
                            {legal.vat}
                            <br />
                            {legal.registry}
                            <br />
                            {legal.incorporation}
                            <br />
                            {legal.jurisdiction}
                            <br />
                            <span
                                style={{
                                    display: "inline-block",
                                    marginTop: 8,
                                    color: "rgba(246,241,234,0.55)",
                                    fontStyle: "italic",
                                }}
                            >
                                {legal.license}
                            </span>
                            <br />
                            <a
                                href={`mailto:${legal.contact_email}`}
                                style={{
                                    marginTop: 12,
                                    display: "inline-block",
                                    color: "var(--gold)",
                                    opacity: 1,
                                }}
                                data-testid="footer-email"
                            >
                                {legal.contact_email}
                            </a>
                            <br />
                            <a
                                href={`tel:${legal.contact_phone.replace(/\s/g, "")}`}
                                style={{
                                    color: "var(--sand)",
                                    opacity: 0.8,
                                }}
                                data-testid="footer-phone"
                            >
                                {legal.contact_phone}
                            </a>
                        </p>
                    </div>
                </div>

                <div className="aurx-footer-bottom">
                    <span>{t("footer.copyright")}</span>
                    <span>{legal.vat}</span>
                </div>
            </div>
        </footer>
    );
}
